export * from './promise/delayed.js';
export * from './promise/is-promise.js';
